/* eslint-disable import/prefer-default-export */
import { isItem, isSubItem } from './utils';

export const items = state => state.items;
export const section = state => state.section;

// Item activo del menú
export const activeItem = state => {
    const index = state.items.findIndex(x => {
        return x.active;
    });
    return index;
};

// Sección activa
export const activeSection = state => {
    return state.section;
};


export const lastItem = state => {
    const length = state.items.length;
    if (length < 1) {
        return null;
    }
    return state.items[length - 1];
};

export const hasItem = state => item => {
    const index = state.items.findIndex(x => {
        return isItem(item, x);
    });
    return index >= 0;
};


export const activeSubItem = state => {
    const index = state.items.findIndex(x => {
        return x.active;
    });
    const subindex = state.items[index].children.findIndex(x => {
        return x.active;
    });
    return subindex;
};

export const activeItemChildrens = state => {
    const index = state.items.findIndex(x => {
        return x.active;
    });
    return state.items[index] && state.items[index].children ? state.items[index].children : [];
};

export const hasItemInChildren = (state, getters) => payload => {
    const i = payload.index || getters.activeItem;
    const subitem = payload.subitem;
    const index = state.items[i].children.findIndex(x => {
        return isSubItem(subitem, x);
    });
    return index >= 0;
};

